var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetflix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 54.6 80",
    style: {
      enableBackground: "new 0 0 54.6 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "testimonial",
    d: "M41.4,65.3c-0.2,0-0.5,0-0.9-0.1c-2.3-0.3-5.4-0.5-7.9-0.7c-0.8,0-1.5-0.1-1.5-0.1s-2.4-6.7-6.9-19.2l-0.7-2 v0.1l0,0v5.9v4.5c0,10.2,0,10.8-0.1,10.8c-0.4,0-3.8,0.2-4.9,0.3c-0.7,0.1-2.2,0.2-3.3,0.3c-1.1,0.1-2,0.2-2,0.2s0-11.5,0-25.4V14.5 l0,0h5.1h5.1l0.1,0.2c0,0.1,0.9,2.4,1.9,5.2c3.7,10.3,4.3,12,5.2,14.5l0.7,2.1v-22h10.3v25.4C41.5,53.2,41.5,64.2,41.4,65.3 L41.4,65.3C41.5,65.3,41.5,65.4,41.4,65.3L41.4,65.3L41.4,65.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetflix);
export default __webpack_public_path__ + "static/media/netflix.92fc592b9dd78e8dbc364ee2ae8add3c.svg";
export { ForwardRef as ReactComponent };